<template>
  <div>
    <Upload
      ref="upload"
      :show-upload-list="showUploadList"
      :default-file-list="fileList"
      :on-success="handleSuccess"
      :accept="accept"
      :format="format"
      :max-size="maxSize"
      :data="data"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :on-error="handleFileUploadError"
      :before-upload="handleBeforeUpload"
      :multiple="multiple"
      :action="action"
      style="display: inline-block;width:auto;"
      :headers="{'Authorization':accessToken}"
    >
      <Button v-if="showButtonText" :type="buttonType" size="small" :icon="icon" shape="circle">
        {{ buttonText }}
      </Button>
      <Button v-else :type="buttonType" size="small" :icon="icon" shape="circle" />

    <!-- ? '(上传文件大小不能超过: ' + (maxSize | formatSize) : '' }}</span> -->
    </Upload>
    <div v-if="showTips" style="color: #8282df; font-size: 8pt;">
      <Icon type="ios-information-circle" />上传文件大小不能超过: <b>{{ maxSize | formatSize }}</b>
    </div>
  </div>
</template>

<script>
import { formatFileSize } from '@/utils/util'
export default {
  name: 'FileUploader',
  filters: {
    formatSize: (size) => {
      return formatFileSize(size)
    }
  },
  props: {
    action: {
      type: String,
      default: '//jsonplaceholder.typicode.com/posts/'
    },
    icon: {
      type: String,
      default: 'ios-cloud-upload'
    },
    params: {
      type: Object,
      default() { return {} }
    },
    showMaxSize: {
      type: Boolean,
      default: true
    },
    showTips: {
      type: Boolean,
      default: true
    },
    index: {
      type: Number,
      default: 0
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: '*'
    },
    showUploadList: {
      type: Boolean,
      default: false
    },
    maxCount: {
      type: Number,
      default: 0
    },
    buttonType: {
      type: String,
      default: 'primary'
    },
    buttonText: {
      type: String,
      default: '上传文件'
    },
    showButtonText: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 1024 * 10
    },
    list: {
      type: Array,
      default() { return [] }
    },
    format: {
      type: Array,
      default() { return [] }
    }
  },
  data() {
    return {
      uploadFile: null,
      fileList: [],
      uploadList: [],
      data: {}
    }
  },
  computed: {
    accessToken() {
      const accessToken = this.$store.state.app.accessToken
      if (accessToken) {
        return `Bearer ${accessToken}`
      }
      return ''
    }
  },
  watch: {
    params(val) {
      this.data = val
    },
    list(val) {
      if (val && val.length === 0) {
        this.fileList = []
        this.uploadList = []
        this.uploadFile = null
      }
    }
  },
  methods: {
    startUpload() {
      if (this.uploadFile) {
        this.$refs.upload.post(this.uploadFile)
      }
    },
    handleSuccess(res, file) {
      if (res.code === 0) {
        file.url = this.$config.cosHost + res.data.file
        file.path = res.data.file
        file.name = res.data.file
        this.$emit('on-upload', file, this.index)
      } else {
        this.$Notice.error({
          title: '文件上传失败',
          desc: '文件' + file.name + ' 上传失败'
        })
      }
    },
    handleFileUploadError(error, file, fileList) {
      this.$Notice.error({
        title: '文件上传失败',
        desc: '文件' + file.name + ' 上传失败: ' + error
      })
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: '文件' + file.name + ' 格式不正确, 请选择下列文件格式: ' + this.acceptedFileFormat.join(',')
      })
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: '上传文件过大',
        desc: '文件  ' + file.name + ' 大小超出上限: ' + formatFileSize(this.maxSize)
      })
    },
    handleBeforeUpload(file) {
      const uploadList = this.$refs.upload.fileList
      if (this.maxCount > 0 && (uploadList.length >= this.maxCount || this.list.length >= this.maxCount)) {
        this.$Notice.error({
          title: '上传文件数量超出上限: ' + this.maxCount
        })
        return false
      } else {
        this.uploadFile = file
        this.$emit('on-before-upload', file, this.index)
        return this.autoUpload
      }
    }
  }
}
</script>
